import React, { useState, useEffect, useRef } from 'react';
import { IoTrash } from 'react-icons/io5';
import cn from 'classnames';
import Loader from '../../General/Loader';

export const IgnoredDomainsList = ({ domains, loading, onDelete, lastAddedDomainId, onScrollComplete }) => {
  const [deletingId, setDeletingId] = useState(null);
  const domainRefs = useRef({});

  useEffect(() => {
    if (lastAddedDomainId && domainRefs.current[lastAddedDomainId]) {
      // Scroll immediately to get the item in view
      domainRefs.current[lastAddedDomainId].scrollIntoView({
        behavior: 'auto',
        block: 'center'
      });

      // Delay clearing the highlight state to allow animation to complete
      setTimeout(() => {
        onScrollComplete?.();
      }, 2100); // Slightly longer than the 2s animation
    }
  }, [lastAddedDomainId, onScrollComplete]);

  const handleDelete = async domain => {
    if (!window.confirm(`Are you sure you want to remove "${domain.domain}" from the ignored domains list?`)) {
      return;
    }

    setDeletingId(domain.id);
    try {
      await onDelete(domain.id);
    } finally {
      setDeletingId(null);
    }
  };

  if (loading) {
    return (
      <div className='ignored-domains-list-section'>
        <div className='loading-container'>
          <Loader />
          <span>Loading domains...</span>
        </div>
      </div>
    );
  }

  return (
    <div className='ignored-domains-list-section'>
      {domains.length === 0 ? (
        <div className='empty-state'>No ignored domains configured</div>
      ) : (
        <div className='ignored-domains-list'>
          {domains.map(domain => (
            <div
              key={domain.id}
              className={cn('domain-item', {
                'newly-added': lastAddedDomainId === domain.id
              })}
              ref={el => (domainRefs.current[domain.id] = el)}
            >
              <div className='domain-info'>
                <span className='domain-name'>{domain.domain}</span>
                <span className='domain-date'>Added {new Date(domain.createdAt).toLocaleDateString()}</span>
              </div>

              <button onClick={() => handleDelete(domain)} disabled={deletingId === domain.id} className='delete-button' title='Remove domain'>
                <IoTrash size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
